import { useCallback, useState } from "react";
import { SearchBrandsInput } from "components/UI/molecules";
import "./index.scss";
import { SearchBrandsDropdown } from "../search-brands-dropdown";

export const HowItWorksSearch = () => {
  const [canShowDropdown, setCanShowDropdown] = useState(false);
  const [brands, setBrands] = useState([]);
  const handleBrandsChange = useCallback((brandsChanged) => {
    setBrands(brandsChanged);
  }, []);

  return (
    <div
      className="how-it-works-search-container"
      data-testid="how-it-works-search"
    >
      <SearchBrandsInput
        placeholder="Try... Nike, Shoes, Starbucks or Coffee"
        searchButtonLabel="Search & Save"
        onBrandsChange={handleBrandsChange}
        shouldShowDropdown={(value) => setCanShowDropdown(value)}
        variant="desktop"
      />
      <div className="dropdown-container">
        <SearchBrandsDropdown
          canShowDropdown={canShowDropdown}
          brands={brands}
        />
      </div>
    </div>
  );
};
